const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
  'DC', 'PR', 'VI', 'GU', 'AS', 'MP'
];

const COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
  'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia',
  'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica',
  'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt',
  'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon',
  'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
  'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel',
  'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kosovo',
  'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania',
  'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius',
  'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia',
  'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Macedonia', 'Norway', 'Oman',
  'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal',
  'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe',
  'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia',
  'South Africa', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan',
  'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan',
  'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City',
  'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe',
  // Common alternative names and abbreviations
  'USA', 'United States of America', 'UK', 'Great Britain', 'UAE', 'U.S.A.', 'U.S.', 'America',
  'Czechia', 'Ivory Coast', 'Côte d\'Ivoire', 'DR Congo', 'Democratic Republic of the Congo',
  'Republic of the Congo', 'North Korea', 'South Korea', 'Macedonia', 'FYROM',
  'Palestinian Territories', 'State of Palestine', 'Syrian Arab Republic',
  'Vatican', 'Holy See', 'Viet Nam', 'Burma', 'Eswatini', 'Swaziland'
];

// Add US territories and common abbreviations
const US_TERRITORIES = [
  'USVI', 'Virgin Islands', 'U.S. Virgin Islands', 'St Croix', 'St. Croix', 'St Thomas', 'St. Thomas', 'St John', 'St. John',
  'Puerto Rico', 'PR', 'Guam', 'GU', 'American Samoa', 'AS',
  'Northern Mariana Islands', 'MP', 'CNMI'
];

// Add common state/territory abbreviations
const STATE_ABBREVIATIONS = {
  'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas',
  'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware',
  'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii', 'ID': 'Idaho',
  'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas',
  'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
  'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
  'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada',
  'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
  'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma',
  'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
  'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah',
  'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia',
  'WI': 'Wisconsin', 'WY': 'Wyoming', 'DC': 'District of Columbia',
  // Add US territories with their abbreviations
  'VI': 'Virgin Islands', 'PR': 'Puerto Rico', 'GU': 'Guam',
  'AS': 'American Samoa', 'MP': 'Northern Mariana Islands',
  // Add St. Croix and other Virgin Islands variations
  'STX': 'St. Croix', 'STT': 'St. Thomas', 'STJ': 'St. John'
};

// Add common country codes and their full names
const COUNTRY_CODES = {
  'USA': 'United States',
  'US': 'United States',
  'U.S.A.': 'United States',
  'U.S.': 'United States',
  'America': 'United States',
  'USVI': 'United States',
  'VI': 'United States',
  'CR': 'Costa Rica',
  'MZ': 'Mozambique',
  // Add more as needed
};

/**
 * Extracts city and country from a location string
 * @param {string} locationString - The full location string
 * @returns {string|null} - Formatted city and country string or null if invalid
 */
export const extractCityAndCountry = locationString => {
  if (!locationString) return null;
  
  // Split the address by commas and trim whitespace
  const parts = locationString.split(',').map(part => part.trim());
  if (parts.length < 2) return locationString;

  // Helper function to check if a string is a postal code
  const isPostalCode = str => {
    // US ZIP code pattern (5 digits or 5+4)
    const usZipPattern = /^\d{5}(-\d{4})?$/;
    // Generic postal code pattern (alphanumeric with possible spaces)
    const genericPostalPattern = /^[A-Z0-9\s-]+$/;
    return usZipPattern.test(str) || genericPostalPattern.test(str);
  };

  // Helper function to check if a string contains a state/territory
  const isStateOrTerritory = str => {
    const upperStr = str.toUpperCase();
    // Check if it's a state abbreviation
    if (STATE_ABBREVIATIONS[upperStr]) return true;
    // Check if it's a US territory
    if (US_TERRITORIES.some(territory => upperStr.includes(territory.toUpperCase()))) return true;
    // Check if it contains "Province" or similar
    if (str.toLowerCase().includes('province')) return true;
    // Check for St. Croix, St. Thomas, etc.
    if (upperStr.includes('ST CROIX') || upperStr.includes('ST. CROIX')) return true;
    if (upperStr.includes('ST THOMAS') || upperStr.includes('ST. THOMAS')) return true;
    if (upperStr.includes('ST JOHN') || upperStr.includes('ST. JOHN')) return true;
    // Check for state abbreviation in the string
    const stateMatch = upperStr.match(/\b[A-Z]{2}\b/);
    if (stateMatch && STATE_ABBREVIATIONS[stateMatch[0]]) return true;
    return false;
  };

  // Helper function to check if a string is a country
  const isCountry = str => {
    const upperStr = str.toUpperCase();
    // Check against country codes
    if (COUNTRY_CODES[upperStr]) return true;
    // Check against full country names
    return COUNTRIES.some(country => 
      upperStr.includes(country.toUpperCase())
    );
  };

  // Helper function to extract state from a string
  const extractState = str => {
    const upperStr = str.toUpperCase();
    // Check for state abbreviation
    const stateAbbr = str.match(/\b[A-Z]{2}\b/);
    if (stateAbbr && STATE_ABBREVIATIONS[stateAbbr[0]]) {
      return STATE_ABBREVIATIONS[stateAbbr[0]];
    }
    // Check for US territories
    const territory = US_TERRITORIES.find(t => upperStr.includes(t.toUpperCase()));
    if (territory) {
      // Special handling for Virgin Islands
      if (upperStr.includes('ST CROIX') || upperStr.includes('ST. CROIX')) return 'St. Croix, Virgin Islands';
      if (upperStr.includes('ST THOMAS') || upperStr.includes('ST. THOMAS')) return 'St. Thomas, Virgin Islands';
      if (upperStr.includes('ST JOHN') || upperStr.includes('ST. JOHN')) return 'St. John, Virgin Islands';
      return territory;
    }
    // Return the string if it contains "Province" or similar
    if (str.toLowerCase().includes('province')) return str;
    return null;
  };

  // Helper function to check if a string looks like a business name
  const isBusinessName = str => {
    const lowerStr = str.toLowerCase();
    return str.match(/[+&]/) || // Contains special characters
           str.length > 30 || // Too long for a city name
           lowerStr.includes('dive') ||
           lowerStr.includes('adventures') ||
           lowerStr.includes('center') ||
           lowerStr.includes('shop') ||
           lowerStr.includes('store') ||
           lowerStr.includes('business') ||
           /^\d+/.test(str); // Starts with numbers
  };

  // Process parts from end to start
  let country = null;
  let city = null;
  let state = null;
  let isUSAddress = false;

  // First pass: look for state in any part
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    if (isStateOrTerritory(part)) {
      state = extractState(part);
      break;
    }
  }

  // Second pass: process from end to start
  for (let i = parts.length - 1; i >= 0; i--) {
    const part = parts[i];
    const upperPart = part.toUpperCase();
    
    // Check for country
    if (!country && isCountry(part)) {
      country = COUNTRY_CODES[upperPart] || part;
      isUSAddress = country.toLowerCase().includes('united states') || 
                   US_TERRITORIES.some(t => upperPart.includes(t.toUpperCase()));
    }
    // Check for city (first non-country, non-state, non-postal code part that doesn't look like a business)
    else if (!city && !isCountry(part) && !isStateOrTerritory(part) && !isPostalCode(part) && !isBusinessName(part)) {
      // Remove any postal code that might be attached to the city
      city = part.replace(/\s+\d{5}(-\d{4})?$/, '').trim();
      // Remove any street address if it's the first part
      if (i === 0) {
        city = city.replace(/^\d+\s+[A-Za-z\s]+(?:Street|St|Avenue|Ave|Road|Rd|Boulevard|Blvd|Drive|Dr|Lane|Ln|Place|Pl|Court|Ct|Circle|Cir|Way|Terrace|Ter|Trail|Trl)\b/i, '').trim();
      }
    }
  }

  // If we still don't have a city, use the first part only if it doesn't look like a business
  if (!city && parts.length > 0) {
    const firstPart = parts[0].replace(/\s+\d{5}(-\d{4})?$/, '').trim();
    if (!isBusinessName(firstPart)) {
      city = firstPart.replace(/^\d+\s+[A-Za-z\s]+(?:Street|St|Avenue|Ave|Road|Rd|Boulevard|Blvd|Drive|Dr|Lane|Ln|Place|Pl|Court|Ct|Circle|Cir|Way|Terrace|Ter|Trail|Trl)\b/i, '').trim();
    }
  }

  // Format the result based on whether it's a US address
  if (isUSAddress) {
    if (city && state && country) {
      // Special handling for Virgin Islands
      if (state.includes('Virgin Islands')) {
        return `${city}, ${state}`;
      }
      return `${city}, ${state}, ${country}`;
    } else if (city && country) {
      // For US addresses, try to find state in the original string
      const stateMatch = locationString.match(/\b([A-Z]{2})\b/);
      if (stateMatch && STATE_ABBREVIATIONS[stateMatch[1]]) {
        return `${city}, ${STATE_ABBREVIATIONS[stateMatch[1]]}, ${country}`;
      }
      return `${city}, ${country}`;
    } else if (country) {
      // If we only have a country for US address
      return country;
    }
  } else {
    if (city && country) {
      return `${city}, ${country}`;
    } else if (country) {
      // If we only have a country, return just the country
      return country;
    }
  }

  // If we have a country but the rest looks like a business name, return just the country
  if (country && parts.some(part => isBusinessName(part))) {
    return country;
  }

  // Fallback to original string if we couldn't parse it properly
  return locationString;
};

// Test cases
if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
  const testCases = [
    '4GXV+6HV Liquid Dive Adventures, Mozambique',
    'Liquid Dive Adventures, Mozambique',
    '123 Main St, New York, NY, USA',
    'San Francisco, CA, United States',
    'St. Thomas, Virgin Islands',
    '123 Dive Center, Florida, USA',
    'Mozambique',
    '123 Adventure Dive Shop, 90210, USA'
  ];

  console.log('Testing extractCityAndCountry function:');
  testCases.forEach(test => {
    console.log(`\nInput: "${test}"`);
    console.log(`Output: "${extractCityAndCountry(test)}"`);
  });
}
